// ----------------------------------------------------------------------------
// Component: Content Cards
// ----------------------------------------------------------------------------
//
// Section displaying a default card consisting of an image,
// title, content and button. It displays a 1, 2 or 3 column grid.
//
//
// ----------------------------------------------------------------------------

import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-control/swiper-control';

// Style includes
import './_content-cards.scss';

const CAROUSEL_SELECTOR = '.carousel--content-cards';
const CAROUSEL_CLASS = 'carousel--content-cards';
const CAROUSEL_SECTION_SELECTOR = '.content-cards';
const CAROUSEL_SECTION_CLASS = 'content-cards';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
function handleContentCards(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        slide.addEventListener('focus', function() {
            var slidePos = swiperEl.$el[0].getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.$el[0].scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= window.innerHeight &&
            slidePos.right <= window.innerWidth)) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - (window.innerHeight / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });
    });
}

function centerSliderArrows(element) {
    let slideImageHeight;
    let slides = element.querySelectorAll('.swiper-slide');
    let arrows = element.querySelectorAll('.swiper-arrow__container');

    slides.forEach((slide, index) => {
        let slideImage = slide.querySelector('.card__image-wrapper');

        if (slideImage) {
            slideImageHeight = slideImage.clientHeight / 2;
        }
    });

    arrows.forEach((arrow) => arrow.style.top = slideImageHeight + 'px');
}

document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {
        if (element.querySelector(CAROUSEL_SELECTOR)) {
            const cards = element.querySelectorAll('.card');

            if (cards.length > 2) {

                // Generate unique class for each slider
                element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

                // Generate unique btn classes for slider arrows
                element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
                element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

                // Generate unique btn classes for swiper pagination
                element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-pagination-${index}`);

                const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
                    // Optional parameters
                    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
                    slidesPerView: 2,
                    spaceBetween: 15,
                    observer: true,
                    observeParents: true,
                    a11y: true,
                    navigation: {
                        nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                        prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
                    },
                    pagination: {
                        el: `.${CAROUSEL_SECTION_CLASS}-pagination-${index}`,
                        type: 'bullets',
                        clickable: true,
                    },
                    on: {
                        beforeTransitionStart: function(swiper) {
                            const parent = swiper.el.closest('.content-cards__carousel-wrapper');
                            const previousIndex = swiper.previousIndex;
                            const activeIndex  = swiper.activeIndex;
                            const bulletIndex = swiper.activeIndex + 1;
                            const nextBullet = parent.querySelector(`.swiper-pagination-bullet:nth-child(${bulletIndex})`);
                            const gooeySlider   = parent.querySelector('.gooey-slider');

                            if (nextBullet !== null && gooeySlider !== null) {
                                const offsetLeft = (previousIndex < activeIndex) ? nextBullet.offsetLeft : nextBullet.offsetLeft;

                                gooeySlider.style.left = `${offsetLeft}px`;
                            }
                        }
                    }
                });

                if (swiper.slides) {
                    handleContentCards(swiper);
                } else {
                    swiper.forEach(function(swiperEl) {
                        handleContentCards(swiperEl);
                    });
                }

                centerSliderArrows(element);
            }
        }
    });

let resizeTimeout;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
        const contentCards = document.querySelectorAll(CAROUSEL_SECTION_SELECTOR);

        contentCards.forEach((section) => {
            centerSliderArrows(section);
        });
    }, 25);
});
